module.exports = {
  REQUEST_BY_CUSTOMER: 'ORIGINAL',
  SPECIFIC_SERVICE: 'RETIRADA',
  BANK_ERROR: 'MED_OPERACIONAL',
  FRAUD: 'MED_FRAUDE'
};
